"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelegatingRSAImpl = void 0;
class DelegatingRSAImpl {
    constructor(encKeyPair, signKeyPair) {
        this.encKeyPair = encKeyPair;
        this.signKeyPair = signKeyPair;
        this.initialized = false;
    }
    async generateKey(bits) {
        await this.signKeyPair.generateKey({ b: bits });
        await this.encKeyPair.loadKeyPair(this.signKeyPair.getPublicKey(), this.signKeyPair.getPrivateKey());
        this.initialized = true;
    }
    async loadKeyPair(publicKey, privateKey) {
        if (this.initialized) {
            throw new Error('RSA key cannot be re-initialized.');
        }
        await this.signKeyPair.loadKeyPair(publicKey, privateKey);
        await this.encKeyPair.loadKeyPair(publicKey, privateKey);
        this.initialized = true;
    }
    getPublicKey() {
        if (!this.initialized) {
            throw new Error('Trying to retrieve public key from uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return this.signKeyPair.getPublicKey();
    }
    getPrivateKey() {
        if (!this.initialized) {
            throw new Error('Trying to retrieve private key from uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return this.signKeyPair.getPrivateKey();
    }
    async sign(text) {
        var _a;
        if (!this.initialized) {
            throw new Error('Trying to create signature using uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return (_a = this.signKeyPair) === null || _a === void 0 ? void 0 : _a.sign(text);
    }
    async verify(text, signature) {
        if (!this.initialized) {
            throw new Error('Trying to verify signature using uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return this.signKeyPair.verify(text, signature);
    }
    async encrypt(plainText) {
        if (!this.initialized) {
            throw new Error('Trying to encrypt using uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return this.encKeyPair.encrypt(plainText);
    }
    async decrypt(cypherText) {
        if (!this.initialized) {
            throw new Error('Trying to decrypt using uninitialized WebCrypto RSA KeyPair wrapper.');
        }
        return this.encKeyPair.decrypt(cypherText);
    }
}
exports.DelegatingRSAImpl = DelegatingRSAImpl;
//# sourceMappingURL=DelegatingRSAImpl.js.map